/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

export enum PRICE_CONFIGURATION_GROUP_NAME {
  WAIVER = 'Waiver',
  USERS = 'Users',
  SHIPMENT = 'Shipment',
  ADD_ON_FEATURE = 'Add-On Feature',
  REFERRAL = 'Referral',
  PROJECT_TYPE_FEE = 'Project Type Fee',
  COMPANY_CONFIG = 'Company Config',
  RS_INSURANCE = 'Insurance',
  RS_CARRIER_VALIDATION_OK_TO_LOAD = 'Carrier Validation - OK To Load',
  RS_CARRIER_TENDER_OPTIONS = 'Carrier Tender Options',
  RS_UPDATING_STATUSES_WITHOUT_CHECK_CALLS = 'Updating Statuses Without Check Calls',
  RS_LOCATION_NAME = 'Location Name',
  RS_SALES_PERSON_REQUIRED = 'Sales Person Required',
  RS_AWARD_TYPE_REQUIRED = 'Award Type Required',
  RS_CUSTOMER_INFO_REQUIRED = 'Customer Info Required',
  RS_QUICKBOOK_INTEGRATION = 'Quickbooks/NetSuite Integration',
  CUSTOM_INVOICE = 'Custom Invoice',
  SASS_INVOICE = 'Saas Invoice',
  PLATFORM_ACCESS = 'Platform Access',
  FEATURES = 'Features',
  FEATURES_ZUUM_CAPACITY_PRO = 'Features (Zuum Capacity Pro)',
  EQUIPMENT_TYPE = 'Equipment type',
  SHIPMENT_OPTIONS = 'Shipment Options',
  CUSTOMERS_FOR_SHIPMENTS = 'Customers For Shipments',
  ACCCOUNTING = 'Accounting',
}
